<template>
    <div style="min-width:900px;">
        <div class="pkg-search-box zone-competition-contain" style="margin-bottom: 15px">
            <el-form class="pkg-content" label-position="left"
                     :model="dataForm"
                     @keyup.enter.native="getDataList()">
                <el-row class="margb10">
                    <el-col :span="7">
                        <!-- 名称 -->
                        <el-form-item label="大赛ID"
                                      class="search-item">
                            <el-input v-model="dataForm.title"
                                      placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <!-- 创建人 -->
                        <el-form-item label="创建人"
                                      class="search-item">
                            <el-input v-model="dataForm.userName"
                                      placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <!-- 状态 -->
                        <el-form-item label="状态"
                                      class="search-item">
                            <el-select v-model="dataForm.status" placeholder="请选择" clearable>
                                <template v-for="status in statusOptions">
                                    <el-option :key="status.value" :label="status.name" :value="status.value"></el-option>
                                </template>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- 查询 -->
                    <el-col :span="3">
                        <el-col :span="24">
                            <el-button class="M-search"
                                       style="margin-bottom: 7px"
                                       type="primary"
                                       @click="getDataListMerge">查询</el-button>
                        </el-col>
                    </el-col>
                </el-row>
                <el-row class="margb10">
                    <el-col :span="9">
                        <!-- 创建时间 -->
                        <el-form-item label="创建时间"
                                      class="search-item"
                                      style="width: 100% !important">
                            <el-date-picker v-model="createTime"
                                            type="daterange"
                                            value-format="yyyy-MM-dd"
                                            start-placeholder="开始时间"
                                            end-placeholder="结束时间"
                                            :clearable="true"
                                            style="width: 100%">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="1"> &nbsp</el-col>
                    <el-col :span="11">
                        <el-form-item label="关联专区" class="search-item">
                                <span slot="label">
                                  <el-link type="primary"
                                           :underline="false"
                                           @click="themeDataCon()">关联专区</el-link>
                                </span>
                            <el-input v-model="dataForm.associatedZonesName"
                                      disabled
                                      placeholder="请选择"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <!-- 重置 -->
                        <el-col :span="24">
                            <el-button class="el-back M-search M-margin-l"
                                       type="info"
                                       @click="again">重置</el-button>
                        </el-col>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="pkg-content">
            <div class="search">
                <!--新增-->
                <el-button  v-if="checkSave()" type="primary"
                           @click="toDetail('add')">{{ $t('add') }}</el-button>
            </div>
            <el-table v-loading="dataListLoading"
                      :data="dataList"
                      tooltip-effect="dark"
                      border
                      :row-style="{height:48+'px'}"
                      :cell-style="{padding:0+'px'}">
                <!--序号-->
                <el-table-column label="序号"
                                 type="index"
                                 width="50"
                                 align="center"
                                 show-overflow-tooltip>
                    <template slot-scope='scope'><span>{{(page-1)*limit + scope.$index+1}}</span></template>
                </el-table-column>
                <!--大赛名称-->
                <el-table-column prop="competitionCode"
                                 label="大赛ID"
                                 header-align="center"
                                 align="left"
                                 show-overflow-tooltip></el-table-column>
                <!--大赛专区-->
                <el-table-column prop="associatedZoneMap"
                                 label="关联专区"
                                 header-align="center"
                                 align="left"
                                 :formatter="themeformat"
                                 show-overflow-tooltip></el-table-column>
                <!--创建人-->
                <el-table-column prop="createUserCN"
                                 label="创建人"
                                 header-align="center"
                                 align="center"
                                 width="100"
                                 show-overflow-tooltip></el-table-column>
                <!--创建时间-->
                <el-table-column prop="createTime"
                                 label="创建时间"
                                 header-align="center"
                                 align="center"
                                 width="160"
                                 show-overflow-tooltip></el-table-column>
                <!--状态-->
                <el-table-column prop="workStatus"
                                 label="状态"
                                 header-align="center"
                                 show-overflow-tooltip
                                 :formatter="statusformat"
                                 width="100"
                                 align="center"></el-table-column>
                <!--操作-->
                <el-table-column label="操作"
                                 header-align="center"
                                 align="center"
                                 min-width="50"
                                 fixed="right">
                    <template slot-scope="scope">
                        <div>
                            <span v-show="checkDetail()" class="el-dropdown-link" @click="toViewDetail('view', scope.row.id)">查看</span> &nbsp;
                            <el-dropdown trigger="click"
                                         placement="bottom">

                                <span class="el-dropdown-link">操作<em class="el-icon-caret-bottom el-icon--right"></em>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-if="scope.row.workStatus != '1' && checkEdit()" @click.native="toDetail('edit', scope.row.id)">编辑
                                    </el-dropdown-item>
                                    <!--显示下架按钮 -->
                                    <el-dropdown-item v-if="scope.row.workStatus == '1' && checkDown()" @click.native="soldOut(scope.row)">下架
                                    </el-dropdown-item>
                                    <!--显示编辑、删除按钮 -->
                                    <template v-if="scope.row.workStatus != '1' && checkDel()">
                                        <el-dropdown-item @click.native="del(scope.row)">删除
                                        </el-dropdown-item>
                                    </template>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page="page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="limit"
                           :total="total"
                           layout="total, sizes, prev, pager, next, jumper"
                           @size-change="pageSizeChangeHandle"
                           @current-change="pageCurrentChangeHandle">
            </el-pagination>
        </div>

        <!--专区搜索-->
        <el-dialog title="选择专区"
                   :visible.sync="isShowThemeCon"
                   width="1100px">
            <div style="margin-top: 5px;">
                <el-row :gutter="5">
                    <!---------------- 左边 ----------------------->
                    <el-col style="width: 70%">
                        <el-card class="box-card">
                            <el-row style="height: 34px; margin-bottom: 20px">
                                <el-col :span="3">
                                    <p style="margin: 0; line-height: 34px">专区名称</p>
                                </el-col>
                                <el-col :span="11">
                                    <el-input v-model="name" :clearable="true"></el-input>
                                </el-col>
                                <el-col :span="10" style="text-align: right">
                                    <el-button type="primary" @click="findThemeCon()">查找</el-button>
                                </el-col>
                            </el-row>

                            <!-- 数据网格 -->
                            <div class="dataBox">
                                <el-table :data="themeListCon"
                                          ref="multipleTableCon"
                                          highlight-current-row
                                          border
                                          row-key="themeId"
                                          v-loading="dataListLoading"
                                          @select="selectRedio"
                                          @select-all="selectRedioAll">
                                    <el-table-column
                                            type="selection"
                                            header-align="center"
                                            align="center"
                                            disabled="true"
                                            width="50">
                                    </el-table-column>

                                    <el-table-column prop="name"
                                                     label="专区名称"
                                                     width="250"
                                                     header-align="center"
                                                     show-overflow-tooltip
                                                     align="center">
                                    </el-table-column>

                                    <el-table-column prop="createUserName"
                                                     label="创建人"
                                                     width="200"
                                                     header-align="center"
                                                     show-overflow-tooltip
                                                     align="center">
                                    </el-table-column>

                                    <el-table-column prop="status"
                                                     label="状态"
                                                     width="197"
                                                     header-align="center"
                                                     show-overflow-tooltip
                                                     :formatter="themeStatusformat"
                                                     align="center">
                                    </el-table-column>

                                </el-table>
                                <el-pagination @size-change="pageSizeChangeHandleCon"
                                               @current-change="pageCurrentChangeHandleCon"
                                               :current-page="pageCon"
                                               :page-sizes="[10, 20, 50, 100]"
                                               :page-size="limitCon"
                                               style="text-align: right"
                                               layout="total, sizes, prev, pager, next, jumper"
                                               :total="totalCon">
                                </el-pagination>

                            </div>
                        </el-card>
                    </el-col>

                    <!---------------------- 右边 ----------------------------------->
                    <el-col style="width: 30%;">
                        <el-card>
                            <div>
                                <el-form>
                                    <div class="location-layout">
                                        <el-row>
                                            <el-col style="width: 70%;height: 34px" align="left">
                                                <p>已选专区</p>
                                            </el-col>
                                            <el-col style="width: 30%;height: 34px">
                                                <el-button type="primary" @click="selectThemeCon(true)">选 择</el-button>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </el-form>
                            </div>
                        </el-card>
                        <el-row :gutter="10">
                            <el-col style="margin-top: 10px !important;" v-for="tag in themesCon"
                                    :key="tag.id">
                                <el-tag show-overflow-tooltip
                                        style="width: 100%;text-align: left"
                                        :key="tag.id"
                                        @close="handleClose(tag)"
                                        closable>
                                    <div style="width:90%;float:left;overflow-x:hidden; overflow-y:hidden; word-break:keep-all; white-space:nowrap;">{{tag.name}}</div>
                                </el-tag>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module'
    export default {
        name: "themeManage",
        mixins: [mixinViewModule],
        data () {
            return {
                mixinViewModuleOptions: {
                    getDataListURL: '/competition/competitionManage/query',
                    getDataListIsPage: true
                },
                dataList: [],
                createTime: [], // 创建时间
                dataForm: {
                    title: '', // 大赛id
                    userName: '', // 创建人
                    status: '', // 状态
                    beginCreateTime: '', // 开始时间
                    endCreateTime: '', // 结束时间
                    associatedZones:[],
                    associatedZonesName: ''
                },
                classifyList: [],
                // 等待转圈
                dataListLoading: false,

                // 专区筛选
                isShowThemeCon: false,
                themeName: '',
                name: '',
                showTag: false,
                themesCon: [],
                themesConHistory: [],
                themeMultipleSelection: [],
                themeMultipleSelectionCon: [],
                themeList: [],
                themeListCon: [],
                page: 1,                    // 当前页码
                pageCon: 1,                    // 当前页码
                limit: 10,                  // 每页数
                limitCon: 10,                  // 每页数
                total: 0,
                totalCon: 0,
                themeId: '', //话题ID

                statusOptions: [
                    {name: "未发布",
                        value: "0"},
                    {name: "已发布",
                        value: "1"},
                    {name: "已下架",
                        value: "2"},
                ]
            }
        },
        components: {
        },
        created(){
            // this.getDataListMerge()

        },
        methods: {
// 查看权限
checkDetail(){
if(this.$hasPermission('joy:learning:megagame:check')){
    return true
}
return false;
},
// 新增权限
checkSave(){
if(this.$hasPermission('joy:learning:megagame:save')){
    return true
}
return false;
},
// 编辑按钮权限
checkEdit(){
if(this.$hasPermission('joy:learning:megagame:edit')){
    return true
}
return false;
},
// 下架按钮权限
checkDown(){
if(this.$hasPermission('joy:learning:megagame:down')){
    return true
}
return false;
},
// 删除按钮权限
checkDel(){
if(this.$hasPermission('joy:learning:megagame:delete')){
    return true
}
return false;
},
            // 查询
            getDataListMerge () {
                this.page = 1
                this.limit = 10
                console.log(this.dataForm)
                this.getDataList()
            },
            getDataList() {
                if (this.createTime === null ) {
                    this.dataForm.beginCreateTime = ''
                    this.dataForm.endCreateTime = ''
                }else if (this.createTime.length>0) {
                    this.dataForm.beginCreateTime = this.createTime[0]
                    this.dataForm.endCreateTime = this.createTime[1]
                }
                let newDataForm = JSON.parse(JSON.stringify(this.dataForm))
                if ('regionIds' in newDataForm) {
                    if (newDataForm.regionIds.length === 0) {
                        newDataForm.regionIds = ''
                    } else {
                        newDataForm.regionIds = newDataForm.regionIds.join(',')
                    }
                }
                this.dataListLoading = true

                this.$request.post(
                    this.mixinViewModuleOptions.getDataListURL,
                    {
                        page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
                        limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
                        params: this.dataForm
                    }
                ).then((res, total, code, data) => {
                    this.dataListLoading = false
                    let resultList = data.data.records
                    this.dataList = !this.mixinViewModuleOptions.getDataListIsPage ? data.data : resultList
                    this.total = this.mixinViewModuleOptions.getDataListIsPage ? data.data.total : 0
                    console.log(this.dataList)
                }).catch(() => {
                    this.dataListLoading = false
                })
            },
            // 重置
            again () {
                this.dataForm = {
                    id: '', // 大赛id
                    title: '', // 大赛id
                    userName: '', // 创建人
                    status: '', // 状态
                    beginCreateTime: '', // 开始时间
                    endCreateTime: '', // 结束时间
                    associatedZones:[],
                    associatedZonesName: ''
                }
                this.createTime = []
                this.getDataListMerge()
            },
            // 状态格式化
            statusformat (row, column, cellValue) {
                // return this.statusOptions.find(item => item.value == cellValue).name
                if (cellValue === '0') {
                    return '未发布'
                } else if (cellValue === '1') {
                    return '已发布'
                } else if (cellValue === '2') {
                    return '已下架'
                } else { return ' ' }
            },
            // 状态格式化
            themeStatusformat (row, column, cellValue) {
                // return this.statusOptions.find(item => item.value == cellValue).name
                if (cellValue === 0) {
                    return '未发布'
                } else if (cellValue === 2) {
                    return '已发布'
                } else if (cellValue === 3) {
                    return '已下架'
                } else { return ' ' }
            },
            //跳转话题新增编辑页
            toDetail(type, id){
                console.log(type,id)
                this.$router.push({
                    name: "zone-competition-competitionAdd",
                    query: {
                        type,
                        id
                    }
                })
            },
            //跳转话题查看页
            toViewDetail(type,id){
                this.$router.push({
                    name: "zone-competition-competitionDetail",
                    query: {
                        type,
                        id
                    }
                })
            },
            //下架
            soldOut (row){
                this.singleActionHandler("下架", "/competition/competitionManage/updateStatus", row,2)
            },
            //删除
            del (row){
                this.singleActionHandler("删除", "/competition/competitionManage/updateStatus", row,3)
            },
            //单数据操作处理
            singleActionHandler(actionName, api, data,status){
                this.$confirm(`是否${actionName}该大赛?`, `${actionName}大赛`, {
                    type: 'warning'
                }).then(() => {
                    this.$request.get(
                        `${api}`,
                        {id:`${data.id}`,status:`${status}`}
                        ).then( r => {
                        this.$message({
                            message: `${actionName}成功`,
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.getDataListMerge()
                            }
                        })
                    })
                }).catch(() => {
                })
            },


            /********************************************************关联专区**************************************************************/
            // 状态格式化
            themeformat (row, column, cellValue) {
                var associatedZone = ''
                for(const key in cellValue){
                    if (associatedZone == '') {
                        associatedZone = associatedZone + cellValue[key]
                    }else {
                        associatedZone = associatedZone +',' + cellValue[key]
                    }
                }
                return associatedZone
            },

            // 关联专区
            themeDataCon() {
                this.isShowThemeCon = true
                this.pageCon = 1
                this.name = ""
                if (this.dataForm.associatedZonesName.length <= 0) {
                    this.themesCon = []
                } else {
                    this.themesCon = JSON.parse(JSON.stringify(this.themesConHistory))
                }
                this.$nextTick(() => { this.$refs.multipleTableCon.clearSelection() })
                this.themeMultipleSelectionCon = []
                // 专区list取得
                this.getDataListCon()
            },
            getDataListCon() {
                this.dataListLoading = true
                // 专区list取得
                this.$request
                    .post('/competition/competitionManage/getZoneList', {
                        page: this.pageCon,
                        limit: this.limitCon,
                    })
                    .then((res, total, code, data) => {
                        this.themeListCon = data.data.themeList
                        this.themeListCon.forEach((row) => {
                            row.createUserName = data.data.userMap[row.createBy].userName
                        })
                        this.pageCon = data.data.pageNo
                        this.limitCon = data.data.pageSize
                        this.totalCon = data.data.totalCount
                        if (this.themesCon && this.isShowThemeCon) {
                            this.themesCon.forEach(data => {
                                this.themeListCon.forEach(row => {
                                    if(data.id === row.id) {
                                        this.$nextTick(() => {
                                            this.$refs.multipleTableCon.toggleRowSelection(row, true)
                                        })
                                    }
                                })
                            })
                        }
                        this.dataListLoading = false
                    })
                    .catch(() => {
                    })
            },
            // 专区查找
            findThemeCon() {
                this.dataListLoading = true
                // 专区查找
                this.$request
                    .post('/competition/competitionManage/getZoneList', {
                        page: 1,
                        limit: 10,
                        name: this.name
                    })
                    .then((res, total, code, data) => {
                        this.themeListCon = data.data.themeList
                        this.themeListCon.forEach((row) => {
                            row.createUserName = data.data.userMap[row.createBy].userName
                        })
                        this.pageCon = data.data.pageNo
                        this.limitCon = data.data.pageSize
                        this.totalCon = data.data.totalCount
                        if (this.themesCon && this.isShowThemeCon) {
                            this.themesCon.forEach(data => {
                                this.themeListCon.forEach(row => {
                                    if(data.id === row.id) {
                                        this.$nextTick(() => {
                                            this.$refs.multipleTableCon.toggleRowSelection(row, true)
                                        })
                                    }
                                })
                            })
                        }
                        this.dataListLoading = false
                    })
                    .catch(() => {
                    })
            },
            // 单选
            selectRedio (selection, row) {
                // 判断当前点击的是打钩还是取消打钩 true 则是打勾
                let isSelected = this.isExistRow(selection, row, 'id')
                if (isSelected) {
                    // 勾选
                    this.themesCon.push(row)
                } else {
                    // 取消勾选
                    for (let i in this.themesCon) {
                        if (this.themesCon[i].id === row.id) {
                            this.themesCon.splice(i, 1)
                        }
                    }
                }
            },

            // 全选
            selectRedioAll (selection) {
                console.log("全选数据："+selection)
                if (selection) {
                    let courseDataB = []
                    courseDataB = this.themesCon
                    if (selection.length > 0) {
                        for (var i = 0; i < selection.length; i++) {
                            let hasFlg = false
                            if (courseDataB.length > 0) {
                                for (var l = 0; l < courseDataB.length; l++) {
                                    if (courseDataB[l].id.toString() === selection[i].id.toString()) {
                                        hasFlg = true
                                    }
                                }
                            }
                            if (!hasFlg) {
                                this.themesCon.push(selection[i])
                            }
                        }
                    } else {
                        if (this.themesCon.length > 0) {
                            this.themeListCon.forEach(item => {
                                let index = this.themesCon.findIndex(it => it.id.toString() === item.id.toString())
                                if (index != -1) {
                                    this.themesCon.splice(index,1)
                                }
                            })
                        }
                    }
                }
            },
            // 选
            isExistRow: function isExistRow (arrs, row, field) {
                let flag = false
                arrs.forEach(function (item) {
                    if (row[field] === item[field]) {
                        flag = true
                    }
                })
                return flag
            },

            // 分页, 每页条数
            pageSizeChangeHandleCon (val) {
                this.pageCon = 1
                this.limitCon = val
                this.getDataListCon()
            },

            // 分页, 当前页
            pageCurrentChangeHandleCon (val) {
                this.pageCon = val
                this.getDataListCon()
            },

            // 专区选择
            selectThemeCon(type) {
                this.dataForm.associatedZonesName = ''
                this.dataForm.associatedZones = []
                var associatedZones = []
                this.themesConHistory = JSON.parse(JSON.stringify(this.themesCon))
                this.themesCon.forEach((element,index) => {
                    if (index == this.themesCon.length - 1) {
                        this.dataForm.associatedZonesName += element.name
                    } else {
                        this.dataForm.associatedZonesName += element.name + "/"
                    }
                    associatedZones.push(element.id)
                });
                this.dataForm.associatedZones = associatedZones
                this.isShowThemeCon = false
            },
            // 删除已选备件
            handleClose (data) {
                for (let a = 0; a < this.themeListCon.length; a++) {
                    // 这是需要用themeId做判断具有唯一性
                    if (data.themeId === this.themeListCon[a].themeId) {
                        this.$refs.multipleTableCon.toggleRowSelection(this.themeListCon[a], false)// 选择当前行
                        break
                    }
                }
                this.themesCon.splice(this.themesCon.indexOf(data),1)
            },



        }
    }
</script>
<style lang="scss" scoped>
@import "../../../css/pkg-styles.css";
.el-date-editor.el-input {
    width: 150px;
}
.search-item {
    width: 94%!important;
}

.el-row {
    margin-bottom: 0px;
}
.search {
    height: 50px;
}
</style>
<style lang="scss">
.zone-competition-contain {
    .search-item .el-form-item__content {
        margin-left: 96px !important;
    }
}
</style>
